import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';
const token = Cookies.get('access_token') || '';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

const HomeService = {
  // 获取配置
  getSkin: async () => {
    const data: IResult | null = await apiGet('/mg/skin/config', {
      PASSBY: true,
      // key: 'fa',
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 获取热门搜索
  getSampleReports: async () => {
    const data: IResult | null = await apiGet('/mg/payrolls/market/sample/reports', {
      PASSBY: true,
      // key: 'x-giants',
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 读取白皮书
  record: async (name: string) => {
    const data: IResult | null = await apiPost('/mg/industry_reports/download', {
      PASSBY: true,
      report_name: name,
      access_token: token,
      // key: 'x-giants',
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 获取视屏
  getVideo: async () => {
    const data: IResult | null = await apiGet('/mg/videos', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 获取薪酬管理最佳实践
  getNew: async () => {
    const data: IResult | null = await apiGet('/mg/news', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // logo列表
  getLog: async () => {
    const data: IResult | null = await apiGet('/mg/logos', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 具体数据
  getData: async () => {
    const data: IResult | null = await apiGet('/mg/params', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
      LOADING: false,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },

  // 合作伙伴
  getPartner: async () => {
    const data: IResult | null = await apiGet('/mg/partner_logos', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
  getMessage: async () => {
    const data: IResult | null = await apiGet('/mg/users/messages?offset=0&limit=3', {
      PASSBY: true,
      // key: 'x-giants',
      access_token: token,
    });
    if (isEmpty(data) || isEmpty(data?.result)) return null;
    return (data as IResult).result;
  },
};


export default HomeService;
